document.addEventListener("DOMContentLoaded", function () {
  menuInit('#menuWrapper');
});

function menuInit(elm){
  var $menuWrapper = $(elm),
  $body = $('body');
  
  $menuWrapper.addClass('hide');
  
  $('#menuButtonWrapper').on('click', function(){

    $menuWrapper.toggleClass('hide').addClass('animation');

    $('#menuWrapper').toggleClass("active");
    $('.btn-trigger').toggleClass('active');

    if ($menuWrapper.hasClass('hide')) {
      $body.removeClass('no-scroll').off('.noScroll');
    } else if(window.innerWidth < 768) {
      $body.addClass('no-scroll').on('touchmove.noScroll', function(e){
        e.preventDefault();
      });
    }
  });
}